<div>
  <h1 class="mt-3 mb-3" style="height: 7%">
    Spells & Abilities
    <button *ngIf="currentTab === 'spells'" class="btn p-0 text-muted mt-2 ml-5" (click)="addSpell()">Add Spell +
    </button>
    <button *ngIf="currentTab === 'abilities'" class="btn p-0 text-muted mt-2 ml-5"
            (click)="addAbility()">Add Ability +
    </button>
  </h1>
</div>
<hr>
<div class="d-flex justify-content-between mt-2 mb-4" style="height: 7%;">
    <div class="card my-auto d-flex flex-column justify-content-center text-center pl-2 pr-2" *ngIf="spellsAndAbilities.spellCastingAbility">
      {{spellsAndAbilities.spellCastingAbility}}
      <span class="border-top">Spell Casting Ability</span>
    </div>
    <div class="card my-auto d-flex flex-column justify-content-center text-center pl-2 pr-2" *ngIf="spellsAndAbilities.spellSave">
      {{spellsAndAbilities.spellSave}}
      <span class="border-top">Spell Save</span>
    </div>
    <div class="card my-auto d-flex flex-column justify-content-center text-center pl-2 pr-2" *ngIf="spellsAndAbilities.spellAttackBonus">
      {{spellsAndAbilities.spellAttackBonus}}
      <span class="border-top">Spell Attack Bonus</span>
    </div>
</div>
<hr>
<mat-tab-group mat-align-tabs="center" [disableRipple]="true" (selectedTabChange)="changeTab($event)">
  <mat-tab label="Spells">
    <div class="spell-ability no-scrollbar p-2" *ngIf="spells">
      <app-spell [spells]="spells" [spellSlots]="spellSlots" (editedSpell)='editSpell($event)'
                 (deletedSpell)='deleteSpell($event)' (slotEmitter)='updateSlots($event)'></app-spell>
    </div>
  </mat-tab>
  <mat-tab label="Abilities">
    <div class="spell-ability no-scrollbar p-2" *ngIf="abilities && abilities.length > 0">
      <app-ability [abilities]="abilities" (editedAbility)="editAbility($event)"
                   (deletedAbility)="deleteAbility($event)"></app-ability>
    </div>
  </mat-tab>
</mat-tab-group>
